/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { CstIndiIncomeDto } from '../model/cstIndiIncomeDto';
import { CustomerInfoDto } from '../model/customerInfoDto';
import { ExtCstAutofillDto } from '../model/extCstAutofillDto';
import { ExtLoanPostDto } from '../model/extLoanPostDto';
import { LocalityDetailsDto } from '../model/localityDetailsDto';
import { NewQuotDto } from '../model/newQuotDto';
import { QuotationDto } from '../model/quotationDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ExtCustomerInfoControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * getAddressbyPincode
     * 
     * @param localDto localDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAddressbyPincodeUsingPOST(localDto: LocalityDetailsDto, observe?: 'body', reportProgress?: boolean): Observable<LocalityDetailsDto>;
    public getAddressbyPincodeUsingPOST(localDto: LocalityDetailsDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LocalityDetailsDto>>;
    public getAddressbyPincodeUsingPOST(localDto: LocalityDetailsDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LocalityDetailsDto>>;
    public getAddressbyPincodeUsingPOST(localDto: LocalityDetailsDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (localDto === null || localDto === undefined) {
            throw new Error('Required parameter localDto was null or undefined when calling getAddressbyPincodeUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<LocalityDetailsDto>(`${this.basePath}/dlp/customer/pincode`,
            localDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getDefaultInfo
     * 
     * @param portfolioId portfolioId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDefaultInfoUsingGET(portfolioId: number, observe?: 'body', reportProgress?: boolean): Observable<ExtCstAutofillDto>;
    public getDefaultInfoUsingGET(portfolioId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ExtCstAutofillDto>>;
    public getDefaultInfoUsingGET(portfolioId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ExtCstAutofillDto>>;
    public getDefaultInfoUsingGET(portfolioId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (portfolioId === null || portfolioId === undefined) {
            throw new Error('Required parameter portfolioId was null or undefined when calling getDefaultInfoUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ExtCstAutofillDto>(`${this.basePath}/dlp/customer/autofill/${encodeURIComponent(String(portfolioId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * saveCstIncomeDetails
     * 
     * @param cstIndiIncome cstIndiIncome
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveCstIncomeDetailsUsingPOST(cstIndiIncome: CstIndiIncomeDto, observe?: 'body', reportProgress?: boolean): Observable<CstIndiIncomeDto>;
    public saveCstIncomeDetailsUsingPOST(cstIndiIncome: CstIndiIncomeDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CstIndiIncomeDto>>;
    public saveCstIncomeDetailsUsingPOST(cstIndiIncome: CstIndiIncomeDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CstIndiIncomeDto>>;
    public saveCstIncomeDetailsUsingPOST(cstIndiIncome: CstIndiIncomeDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cstIndiIncome === null || cstIndiIncome === undefined) {
            throw new Error('Required parameter cstIndiIncome was null or undefined when calling saveCstIncomeDetailsUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CstIndiIncomeDto>(`${this.basePath}/dlp/customer/income`,
            cstIndiIncome,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * saveLoanTermsDetails
     * 
     * @param extLoanPostDto extLoanPostDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveLoanTermsDetailsUsingPOST(extLoanPostDto: ExtLoanPostDto, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public saveLoanTermsDetailsUsingPOST(extLoanPostDto: ExtLoanPostDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public saveLoanTermsDetailsUsingPOST(extLoanPostDto: ExtLoanPostDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public saveLoanTermsDetailsUsingPOST(extLoanPostDto: ExtLoanPostDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (extLoanPostDto === null || extLoanPostDto === undefined) {
            throw new Error('Required parameter extLoanPostDto was null or undefined when calling saveLoanTermsDetailsUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<boolean>(`${this.basePath}/dlp/customer/loan`,
            extLoanPostDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * saveNewQuot
     * 
     * @param newQuot newQuot
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveNewQuotUsingPOST1(newQuot: NewQuotDto, observe?: 'body', reportProgress?: boolean): Observable<QuotationDto>;
    public saveNewQuotUsingPOST1(newQuot: NewQuotDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<QuotationDto>>;
    public saveNewQuotUsingPOST1(newQuot: NewQuotDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<QuotationDto>>;
    public saveNewQuotUsingPOST1(newQuot: NewQuotDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (newQuot === null || newQuot === undefined) {
            throw new Error('Required parameter newQuot was null or undefined when calling saveNewQuotUsingPOST1.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<QuotationDto>(`${this.basePath}/dlp/customer/newQuote`,
            newQuot,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * savePersonalInfo
     * 
     * @param customerInfoDto customerInfoDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public savePersonalInfoUsingPOST(customerInfoDto: CustomerInfoDto, observe?: 'body', reportProgress?: boolean): Observable<CustomerInfoDto>;
    public savePersonalInfoUsingPOST(customerInfoDto: CustomerInfoDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CustomerInfoDto>>;
    public savePersonalInfoUsingPOST(customerInfoDto: CustomerInfoDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CustomerInfoDto>>;
    public savePersonalInfoUsingPOST(customerInfoDto: CustomerInfoDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (customerInfoDto === null || customerInfoDto === undefined) {
            throw new Error('Required parameter customerInfoDto was null or undefined when calling savePersonalInfoUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CustomerInfoDto>(`${this.basePath}/dlp/customer/info`,
            customerInfoDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
